import NormalFeed from '@/components/NormalFeed'
import { unwrappedFeedAtom } from '@/atoms/feed'
import { TFeedSubRequest } from '@/types'
import { useAtomValue } from 'jotai'
import { feedKinds } from '@/universe'

export default function HardcodedFeed() {
  const feed = useAtomValue(unwrappedFeedAtom)
  const item =
    feed && 'hardcodedFeed' in feed
      ? window.hallway.universe.hardcodedFeeds[feed.hardcodedFeed]
      : undefined

  if (!item) return null

  const requests: TFeedSubRequest[] = []
  const kinds = item.kinds ?? feedKinds

  if (item.relays?.length) {
    requests.push({
      source: 'relays',
      urls: item.relays,
      filter: {
        kinds
      }
    })
  }

  if (item.pubkeys?.length) {
    // local source: queries the local store and listens for live updates.
    // subscribeTimeline will fall back to outbox relays if the local store has nothing.
    requests.push({
      source: 'local',
      filter: {
        authors: item.pubkeys,
        kinds
      }
    })
  }

  return <NormalFeed subRequests={requests} fixedKinds={!!item.kinds} />
}
